import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from './error.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
    private injector = inject(Injector);

    override handleError(error: Error | HttpErrorResponse) {
        const errorService = this.injector.get(ErrorService);

        let message: string;

        if (error instanceof HttpErrorResponse) {
            // Server error
            message = errorService.getServerErrorMessage(error);
        } else {
            // Client Error
            message = errorService.getClientErrorMessage(error);
        }
        super.handleError(error);
    }
}
